module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_31.b3d7b803.png";